import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Field, reduxForm, change } from 'redux-form';
import { Title } from '@app/src/common/Title';
import { TabProfile } from '@app/src/views/StepPayment/formPayment';
import {
  TermsAndConditions,
  LinkTermsAndConditions,
  FormWrapper,
  PaymentSummary,
  SummaryDescription,
  TextDescription
} from './styled';
import { renderCheckbox } from '@app/src/common/Checkbox';
import { Disclaimer } from '@app/src/common/Disclaimer';
import * as validate from '@app/src/utils/validations';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { CATEGORIES } from '@app/src/config/categories';
import {
  fetchPrice,
  createDniData,
  updateDniData,
  createRucData,
  updateRucData,
  sendDataPayment
} from '@app/src/views/StepPayment/formPayment';
import { isClientEnv } from '@app/src/utils/validations';
import { FormActions } from '@app/src/views/StepPayment/formPayment/components/FormActions';
import { ModalProcessPayment } from '@app/src/views/StepPayment/formPayment/components/ModalProcessPayment';
import { setPrintGeneral } from '@app/src/views/StepTwo/channelPublication';
import { fetchValidate, setUserPasarella } from '@app/src/common/session';
import { COLORS } from '@app/src/ui';
import { clearProcessConfirmData } from '@app/src/views/StepConfirm/sectionConfirm';

const isClient = isClientEnv();
const STATE_PAYMENT = {
  SUCESS: 'approved',
  PENDING: 'pending',
  DENIED: 'denied',
  FAILURED: 'failed'
};

interface Props {
  handleSubmit?: Function;
  reset?: Function;
  touch?: Function;
  untouch?: Function;
  clearSubmitErrors?: Function;
}

const Form: React.FC<Props> = ({ handleSubmit, untouch }) => {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const priceTotal = useSelector(state => state.price.data.total);
  const price = useSelector(state => state.price.data);
  const isLoading = useSelector(state => state.price.isFetching);
  const error = useSelector(state => state.price.error);
  const currentDocumentType = useSelector(state => state.form.stepPayment.values.documentType);
  const currentTerms = useSelector(state => state.form.stepPayment.values.termsAndConditions);
  const currentPhone = useSelector(state => state.form.stepPayment.values.phone);
  const currentBusinessPhone = useSelector(state => state.form.stepPayment.values.businessPhone);
  const dniData = useSelector(state => state.dni.data);
  const rucData = useSelector(state => state.ruc.data);
  const isLoadingDniCreate = useSelector(state => state.dni.isFetchingCreate);
  const isLoadingDniUpdate = useSelector(state => state.dni.isFetchingUpdate); const isLoadingRucCreate = useSelector(state => state.ruc.isFetchingCreate);
  const isLoadingRucUpdate = useSelector(state => state.ruc.isFetchingUpdate);
  const isLoadingPayment = useSelector(state => state.payment.isFetching);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const [isShowModal, setIsShowModal] = useState(false);
  const statusPayment = useSelector(state => state.processConfirm.data.status);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const [buildData, setBuildData] = useState(null);
  const [isPayment, setIsPayment] = useState(false);
  const [typePasarella, setTypePasarella] = useState('');
  const [theme, setTheme] = useState(null);
  const category = theme && theme.id;

  const getKeyfromUrl = () => {
    const completeUrl = location.pathname.split('/')[1].split('-');
    const keyUrl = completeUrl[0];
    let keyWord = '';
    if (keyUrl === 'publica') {
      keyWord = 'purchase-print';
      const categoryAlias = completeUrl[2];
      setTheme(CATEGORIES[categoryAlias]);
    }
    setTypePasarella(keyWord);
  };

  useEffect(() => {
    if (isClient) {
      getKeyfromUrl();
      let head = document.getElementsByTagName('head')[0];
      head.insertBefore(createCulqiScript(), head.firstChild);
      return () => {
        head.removeChild(head.childNodes[0]);
      }
    }
  }, []);

  useEffect(() => {
    if (typePasarella === 'purchase-print') {
      if (print && print.general && theme && print.general.category === theme.id) {
        dispatch(fetchPrice(theme && theme.id, id));
        dispatch(setPrintGeneral(print.general));
      }
    }
  }, [typePasarella]);

  useEffect(() => {
    if (userStorage && userStorage.jwt && validate && validate.email && isPayment) {
      setIsPayment(false);
      sendForm(buildData);
    }
  }, [validate, isPayment, buildData]);

  useEffect(() => {
    if (isClient) {
      (window as any).paymentProcess = true;
    }
  }, []);

  const redirectToConfirmView = (statusConfirm) => {
    let urlConfirm = '';
    if (statusConfirm === STATE_PAYMENT.DENIED) {
      setIsShowModal(false);
      dispatch(clearProcessConfirmData())
      return;
    }
    if (typePasarella === 'purchase-print') {
      sessionStorage.setItem('print', JSON.stringify({ general: { category } }));
      if (statusConfirm === STATE_PAYMENT.SUCESS) {
        urlConfirm = '/confirmacion-de-pago';
      }
      if (statusConfirm === STATE_PAYMENT.PENDING) {
        urlConfirm = '/pendiente-de-pago';
      }
      history.push(urlConfirm, { from: 'purchase-print' });
    }
  };

  useEffect(() => {
    if (isClient && statusPayment) {
      const updateUser = { ...userStorage };
      delete updateUser.uniqueId;
      localStorage.setItem('user', JSON.stringify(updateUser));
      redirectToConfirmView(statusPayment);
    }
  }, [statusPayment]);

  const createCulqiScript = () => {
    if (isClient) {
      let script = document.createElement('script');
      script.setAttribute('src', 'https://js.culqi.com/checkout-js');
      script.setAttribute('id', 'srcCulqi');
      return script;
    }
  };

  const buildPaymentData = () => {
    const data = {
      user: userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id,
      package: false,
      printDetail: id
    };
    if (typePasarella === 'purchase-print') {
      return {
        ...data,
        package: false,
        category
      }
    }
  }

  const sendForm = useCallback((data => {
    let profileData = dniData;
    const paymentData = buildPaymentData();
    if (currentDocumentType === 'RUC') {
      profileData = rucData;
    }
    if (Object.keys(profileData).length === 0) {
      if (currentDocumentType === 'DNI') {
        dispatch(createDniData(data, paymentData, priceTotal, setIsShowModal));
        return;
      }
      if (currentDocumentType === 'RUC') {
        dispatch(createRucData(data, paymentData, priceTotal, setIsShowModal));
        return;
      }
    } else {
      if (currentDocumentType === 'DNI' && isChangeInputsTicketContact(profileData)) {
        dispatch(updateDniData(data, profileData.documentNumber, paymentData, priceTotal, setIsShowModal));
        return;
      }
      if (currentDocumentType === 'RUC' && isChangeInputsBillContact(profileData)) {
        dispatch(updateRucData(data, profileData.documentNumber, paymentData, priceTotal, setIsShowModal));
        return;
      }
      dispatch(sendDataPayment({
        ...paymentData,
        customer: profileData.id
      }, priceTotal, setIsShowModal));
    }
  }), [currentDocumentType, priceTotal, dniData, currentPhone, rucData, currentBusinessPhone]);

  const redirectFromPage = () => {
    if (typePasarella === 'purchase-print') {
      history.push('/inicia-tu-sesion', { from: 'purchase-print' });
    }
  }

  const handleClickSubmit = (data): void => {
    if (typePasarella === 'purchase-print') {
      pushDatalayer(theme.name, data);
    }
    dispatch(setUserPasarella(typePasarella));
    setIsPayment(true);
    setBuildData(data);
    if (userStorage && userStorage.jwt) {
      dispatch(fetchValidate());
    } else {
      redirectFromPage();
    }
  };

  const getProfileType = (value: string): void => {
    dispatch(change('stepPayment', 'documentType', value));
  };

  const handleChangeCheckbox = (value: boolean): void => {
    dispatch(change('stepPayment', 'termsAndConditions', value));
  };

  const isChangeInputsTicketContact = (profileData) => {
    return currentPhone !== profileData.phone;
  }

  const isChangeInputsBillContact = (profileData): boolean => {
    return currentBusinessPhone !== profileData.phone;
  };

  const pushDatalayer = (categoryName: string, data) => {
    const document = data.documentType;
    let ticket = 'Boleta';
    let phone = data.phone;
    if (document === 'RUC') {
      ticket = 'Factura';
      phone = data.businessPhone;
    }
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso 4 - ${categoryName}`,
        'eventLabel': `${ticket}|${phone}`,
        'eventValue': 1
      })
    }
  };

  const setTextButtonNext = useCallback((): string => (isLoading || error) ? 'cargando...' : `Pagar S/ ${priceTotal}`, [isLoading, error]);

  const setDisabledButtonNext = (): boolean => isLoading || isLoadingDniCreate || isLoadingDniUpdate || isLoadingPayment || isLoadingRucCreate || isLoadingRucUpdate;

  const handleClickBack = () => {
    if (typePasarella === 'purchase-print') {
      history.push(`${theme.paths.purchasePrint.stepSummary}/${id}`);
    }
  };

  return (
    <React.Fragment>
      <ModalErrorFeature />
      <FormWrapper onSubmit={handleSubmit(handleClickSubmit)}>
        <Title>Tipo de comprobante</Title>
        <TabProfile
          handleChangeAction={untouch}
          getProfileType={getProfileType}
          color={COLORS.BLUE_LINK} />
        <Field
          name="termsAndConditions"
          component={renderCheckbox}
          checked={currentTerms}
          handleChange={handleChangeCheckbox}
          validate={[validate.required]}
          colorActive={COLORS.BLUE_LINK}
        >
          <TermsAndConditions>
            Acepto los <LinkTermsAndConditions target="_blank" color={COLORS.BLUE_LINK} href="/terminos-y-condiciones">Términos y Condiciones</LinkTermsAndConditions> / <LinkTermsAndConditions target="_blank" color={COLORS.BLUE_LINK} href="/politicas-de-privacidad">Política de privacidad</LinkTermsAndConditions> de Clasificados.pe
          </TermsAndConditions>
        </Field>
        <PaymentSummary color={'#f0f0f0'}>
          {
            isLoading ? 'Cargando...' :
              <React.Fragment>
                {
                  price && price.subTotal ?
                    <SummaryDescription>
                      <TextDescription>Sub Total</TextDescription>
                      <TextDescription>{price && `S/ ${price.subTotal}`}</TextDescription>
                    </SummaryDescription> : null
                }
                {
                  price && price.discount ?
                    <SummaryDescription>
                      <TextDescription>Descuento ({price && price.discount}%)</TextDescription>
                      <TextDescription>{price && `S/ ${price.totalDiscount}`}</TextDescription>
                    </SummaryDescription> : null
                }
                <SummaryDescription>
                  <TextDescription>IGV ({price && price.igv}%)</TextDescription>
                  <TextDescription>{price && `S/ ${price.igvTotal}`}</TextDescription>
                </SummaryDescription>
                <SummaryDescription>
                  <TextDescription isBold>Total a pagar (Inc. IGV.)</TextDescription>
                  <TextDescription isBold>{price && `S/ ${price.total}`}</TextDescription>
                </SummaryDescription>
              </React.Fragment>
          }
        </PaymentSummary>
        <Disclaimer typePasarella={typePasarella} />
        <FormActions
          disabledButtonNext={setDisabledButtonNext()}
          textButtonNext={setTextButtonNext()}
          handleClickBack={handleClickBack}
          textButtonBack="Confirmar publicación"
          priceTotal={priceTotal}
        />
        <ModalProcessPayment isDisplay={isShowModal} />
      </FormWrapper>
    </React.Fragment>
  )
};

const FormHoc = reduxForm({
  form: 'stepPayment',
  initialValues: {
    dni: '',
    name: '',
    fatherLastName: '',
    motherLastName: '',
    email: '',
    phone: '',
    ruc: '',
    rznSocial: '',
    businessName: '',
    businessFatherLastName: '',
    businessMotherLastName: '',
    businessAddress: '',
    businessPhone: '',
    businessEmail: '',
    districtId: '',
    departmentId: '',
    documentType: 'DNI'
  }
})(Form);

export { FormHoc as FormPayment };
